import { disableNavLinks, NavBarDataInterface, NavLinkInterface } from '@simOn/common/containers';
import { PrivilegesFacade } from '@simOn/privileges';
import { GeneralPrivilegeTypeStringify } from '@simOn/privileges/element/models';
import { PublicLinkService } from '@simOn/public-link';
import { publicLinkUnsupportedTooltip } from '@simOn/public-link/models';
import { combineLatest, map } from 'rxjs';

export const PROPERTY_SETTINGS_PAGE_DATA: NavBarDataInterface = {
  headerTitle: $localize`:@@SPACE_SETTINGS_MAIN_TITLE:Space settings`,
  shortTitle: $localize`:@@SPACE_SETTINGS_SHORT_TITLE:Settings`,
  navLinks: [
    {
      label: $localize`:@@SPACE_SETTINGS_GENERAL_INFO:General info`,
      name: `General info`,
      path: `general-informations`,
      icon: 'info'
    },
    {
      label: $localize`:@@SPACE_SETTINGS_ROOMS:Rooms`,
      name: 'Rooms',
      path: 'rooms',
      icon: 'rooms'
    },
    {
      label: $localize`:@@SPACE_SETTINGS_ASSET_CATEGORIES:Asset Categories`,
      name: 'Asset categories',
      path: 'asset-categories',
      icon: 'assignment'
    },
    {
      label: $localize`:@@SPACE_SETTINGS_USERS:Users`,
      name: 'Users',
      path: `users`,
      icon: 'people_alt'
    },
    {
      name: `Role templates`,
      label: $localize`:@@SPACE_SETTINGS_ROLE_TEMPLATES:Role templates`,
      path: `role-templates`,
      icon: 'role_templates'
    },
    {
      name: `History log`,
      label: $localize`:@@SPACE_SETTINGS_HISTORY_LOG:History log`,
      path: `activity-log`,
      icon: 'history_log'
    }
  ],
  activeLinkIndex: 0
};

export function PROPERTY_SETTINGS_PAGE_DATA_WITH_PRIVILEGES(
  privilegesFacade: PrivilegesFacade,
  publicLinkService: PublicLinkService
) {
  const publicLinkUnsupported = publicLinkUnsupportedTooltip();
  return combineLatest([
    privilegesFacade.generalPrivileges$,
    privilegesFacade.isOwner$,
    privilegesFacade.isAdmin$,
    publicLinkService.isPublicLinkModeActive$
  ]).pipe(
    map(
      ([generalPrivileges, isOwner, isAdmin, isPublicLinkModeActive]: [
        GeneralPrivilegeTypeStringify[],
        boolean,
        boolean,
        boolean
      ]): NavBarDataInterface => {
        // A visitor may open General info only; the other sections stay visible but disabled with a tooltip.
        if (isPublicLinkModeActive) {
          const locked = PROPERTY_SETTINGS_PAGE_DATA.navLinks.filter((link) => link.name !== 'General info');
          return {
            ...PROPERTY_SETTINGS_PAGE_DATA,
            navLinks: disableNavLinks(
              PROPERTY_SETTINGS_PAGE_DATA.navLinks,
              locked.map((link) => link.name),
              publicLinkUnsupported
            )
          };
        }
        const canManage =
          generalPrivileges.includes('CanCreateRoomsAndUsersAndRolesAndAssetCategories') || isOwner || isAdmin;
        const canViewLog = generalPrivileges.includes('CanViewApartmentEvents') || isOwner || isAdmin;
        return {
          ...PROPERTY_SETTINGS_PAGE_DATA,
          navLinks: PROPERTY_SETTINGS_PAGE_DATA.navLinks.map((navLink: NavLinkInterface) => {
            if (navLink.name === 'History log') return { ...navLink, hasPrivilege: canViewLog };
            if (navLink.name === 'Users' || navLink.name === 'Role templates') {
              return { ...navLink, hasPrivilege: canManage };
            }
            return navLink;
          })
        };
      }
    )
  );
}
